<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="primary-title xtium-title">{{ $t('additionalOptions') }}</div>
    <EcsAdditionalOption
      v-for="additionalOption in additionalOptions"
      :key="additionalOption.textFieldLabel"
      :additional-option="additionalOption"
      :disabled="disableControls"
      @checkboxClick="onEnableFieldClick"
      @textFieldChange="onTextFieldChange"
    />
  </div>
</template>

<script>
import EcsAdditionalOption from '@/components/ecs-additional-options/EcsAdditionalOption';
import EcsDisableControlsMixin from '@/mixins/EcsDisableControlsMixin';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EcsAdditionalOptions',
  components: { EcsAdditionalOption },
  mixins: [EcsDisableControlsMixin],
  computed: {
    ...mapGetters(['theme']),
    additionalOptions() {
      const additionalOptions = [];
      Object.keys(this.theme.optionalFields).forEach(key => {
        additionalOptions.push({
          key,
          fieldInformation: this.theme.optionalFields[key],
          checkboxLabel: `${key}Enable`,
          textFieldLabel: `${key}Enter`
        });
      });

      return additionalOptions;
    }
  },
  methods: {
    ...mapActions(['updateOptionalField']),
    onEnableFieldClick(field, label, display) {
      this.updateOptionalField({ payload: { field, property: 'display', value: display }, vuetify: this.$vuetify });
    },
    onTextFieldChange(field, label) {
      this.updateOptionalField({ payload: { field, property: 'label', value: label }, vuetify: this.$vuetify });
    }
  }
};
</script>

<style></style>
